/**
 * Read and validate JSON props for an island from its `react-island-props-{id}` sidecar element.
 * Falls back to an empty object for a missing id/element, a non-object payload, or invalid JSON.
 * @param {string | undefined} propsId
 * @returns {Record<string, unknown>}
 */
export function readIslandProps(propsId) {
	let props = {};

	const hasValidPropsId = typeof propsId === 'string' && propsId !== '';
	if (hasValidPropsId) {
		const propsElement = document.getElementById(`react-island-props-${propsId}`);
		if (propsElement) {
			try {
				const parsed = JSON.parse(propsElement.textContent ?? '{}');
				const isPlainObject = parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed);
				if (isPlainObject) {
					props = parsed;
				}
			} catch (parseError) {
				console.warn('react-islands: invalid props JSON', propsId, parseError);
			}
		}
	}

	return props;
}
